import { NavLink, useParams } from 'react-router-dom';
import { PageTitle, useCacheRecord } from 'gossamer-front-end';
import { BookingExtendedView } from 'cb-model';
import { AttendeeCertificateDownloadButton, makeEventUrlSlug } from 'shared-front-end';

export const CaptureEventFeedbackSuccess = (): React.JSX.Element => {
  const { ticketBookingId } = useParams<{ ticketBookingId: string }>();
  const bookingRecord = useCacheRecord(BookingExtendedView, ticketBookingId, !ticketBookingId);
  const booking = bookingRecord.data;
  return (
    <div>
      <PageTitle title="Thank you for your feedback!" />
      <div>
        Download your certificate:
        <br />
        <AttendeeCertificateDownloadButton ticketBookingId={Number(ticketBookingId)} />
        <br />
      </div>
      {booking && (
        <div>
          <NavLink to={`/website/events/${makeEventUrlSlug(booking?.title || '', booking?.event_id)}`}>
            Return to event
          </NavLink>
        </div>
      )}
    </div>
  );
};
